<template>
  <ModalAuth v-if="user === false" @open="closeMenu">
    <CustomButton class="user-button" @click="onLoginClick">
      <template #icon>
        <LoginIcon />
      </template>
      <span class="user"> Login </span>
    </CustomButton>
  </ModalAuth>
  <Dropdown v-else>
    <CustomButton class="user-button" :class="['svg-icon', 'dark']">
      <template #icon>
        <UserIcon fill="var(--font-color)" />
      </template>
      <span class="user">
        {{ user && user.username }}
      </span>
    </CustomButton>

    <template #body>
      <div class="sets">
        <ConfirmEmail v-if="user && !user.email_verified">
          <a class="set-item" href="#" @click="$emit('closeMenu')">{{
            $t("confirm_email.title")
          }}</a>
        </ConfirmEmail>
        <ModalUserSettings>
          <a class="set-item" href="#" @click="$emit('closeMenu')"
            >Profile settings</a
          >
        </ModalUserSettings>
        <a class="set-item" @click="logout">Logout</a>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import CustomButton from "./form/CustomButton.vue";
import UserIcon from "./icons/User.vue";
import LoginIcon from "./icons/Login.vue";
import ModalUserSettings from "../modal/UserSettings.vue";
import Dropdown from "./Dropdown.vue";
import ModalAuth from "../modal/Auth.vue";
import ConfirmEmail from "../modal/ConfirmEmail.vue";

export default {
  name: "UserMenu",
  components: {
    CustomButton,
    UserIcon,
    ModalUserSettings,
    Dropdown,
    LoginIcon,
    ModalAuth,
    ConfirmEmail,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    logout() {
      return this.$store.dispatch("logout").then(() => {
        // this.$router.go();
      });
    },
    closeMenu() {
      this.$emit("close-menu");
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 60px;
  font-weight: 400;
}

.user-button {
  padding: 10px 20px;
}

.sets {
  width: 160px;
  background-color: var(--body-color);
  border: 1.5px solid var(--font-color);
  border-radius: 10px;
  overflow: hidden;
  transform: translateX(-45px);
}

.set-item {
  display: inline-block;
  padding: 10px 15px;
  width: 160px;
  color: var(--font-color);
  border-bottom: 1.5px solid var(--font-color);
  font-weight: 500;

  &:hover {
    color: var(--brand-color);
    background-color: var(--body-color-second);
  }
}
</style>
